import * as React from 'react';
import { fetchApi } from '../../services/api';
import { formatNumber } from '@progress/kendo-intl';
import { Button } from '@progress/kendo-react-buttons';
import { getServiceTeamName } from 'utils/utils';

type State = {
  loading: boolean;
  dailyChart: number[];
  marginTotal: number;
  dailyRevenue: any[];
  error?: string;
}

type Props = {
  margin?: boolean;
  filter: { Name: string, Filter: string };
}

export default class DailyRevenueBrokerage extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      dailyChart: [],
      marginTotal: 0,
      dailyRevenue: [],
    }

    this.refreshData = this.refreshData.bind(this);
  }

  public componentDidMount() {
    this.refreshData();
  }

  public refreshData() {
    fetchApi(`/api/Report/RevenueTodayBrokerage/${this.props.filter.Filter}`)
      .then((response: Array<{ ServiceTeamID: number, TotalCharges: number, TotalExpenses: number, GrossMargin: number, RevenuePercentage: number }>) => {
        this.setState({
          loading: false,
          dailyChart: response.map(x => x.TotalCharges),
          marginTotal: response.reduce((a, b) => { return a + b.GrossMargin }, 0),
          dailyRevenue: response,
          error: undefined,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error?.detail || 'Failed to load data'
        });
      });
  }

  public render() {
    if (this.state.loading) {
      return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card"></div>;
    }

    if (this.state.error) {
      return (
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card text-center p-3">
          <p style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.error}</p>
          <Button onClick={this.refreshData} fillMode='flat'>
            Retry
          </Button>
        </div>
      );
    }

    return <React.Fragment>
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card">
          <p>
            <span className="report-card-title">{this.props.filter.Name} Daily Brokerage</span>
            <br />
            {formatNumber(this.state.dailyChart.reduce((a, b) => { return a + b }, 0), "c0")} Total Revenue
            {this.props.margin && <><br />{formatNumber(this.state.marginTotal, "c0")} Gross Margin</>}
          </p>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Service Team</th>
                <th style={{ textAlign: 'right' }}>{this.props.margin ? 'Margin %' : 'Revenue'}</th>
              </tr>
            </thead>
            <tbody>
              {this.state.dailyRevenue.map((revenue, index) => {
                return <tr key={index}>
                  <td>{getServiceTeamName(revenue.ServiceTeamID)}</td>
                  {this.props.margin
                    ? <td style={{ textAlign: 'right' }}>{formatNumber(revenue.RevenuePercentage, { style: 'percent' })}</td>
                    : <td style={{ textAlign: 'right' }}>{formatNumber(revenue.TotalCharges, "c0")}</td>}
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </React.Fragment>
  }
}
